// Rails libraries
import Rails from "@rails/ujs"
import { FetchRequest } from '@rails/request.js'
Rails.start()

// Import third-party libraries
import 'bootstrap'
import 'jquery'
import '@popperjs/core'
import GLightbox from 'glightbox'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

// Stimulus setup
import { Application } from "@hotwired/stimulus"
import "@hotwired/turbo-rails"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

// Initialize Stimulus
window.Stimulus = Application.start()
const context = require.context("../controllers", true, /\.js$/)
Stimulus.load(definitionsFromContext(context))

// Make FetchRequest available globally
window.FetchRequest = FetchRequest

// loads the Icon plugin
UIkit.use(Icons)

// Initialize GLightbox globally
// window.lightbox = GLightbox({
//   touchNavigation: true,
//   loop: true,
//   autoplayVideos: true
// });
let lightbox = null

// Variables for form handling
let carSoldCheckbox = null
let carReservedCheckbox = null
let carShowSoldOnPublic = null

// Function to handle the mutual exclusivity
function handleCheckboxClick(event) {
  if (event.target.checked) {
    if (event.target === carSoldCheckbox) {
      carReservedCheckbox.checked = false
      if(carSoldCheckbox.checked) {
        carShowSoldOnPublic.classList.remove('d-none')
      } else {
        carShowSoldOnPublic.classList.add('d-none')
      }
    } else if (event.target === carReservedCheckbox) {
      carSoldCheckbox.checked = false
    }
  }
}

function handleThumbClick(event) {
  event.preventDefault()
  const thumb = event.target
  if (thumb) {
    const index = thumb.dataset.lightboxIndex
    if (index) {
      lightbox.openAt(index)
      console.log('Opening lightbox at index:', index)
    }
  }
}

// Initialize everything when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM Content Loaded - Initializing...")
  lightbox = GLightbox({
    touchNavigation: true,
    loop: true,
    autoplayVideos: true
  });

  
  // Back to top button
  const backToTopButton = document.getElementById("backToTop");
  if (backToTopButton) {
    window.onscroll = function() {
      if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        backToTopButton.style.display = "block";
      } else {
        backToTopButton.style.display = "none";
      }
    };

    backToTopButton.onclick = function() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    };
  }

  // Initialize thumbnails
  const thumbnails = document.querySelectorAll('a.glightbox')
  thumbnails.forEach(function (thumbnail) {
    thumbnail.classList.remove('disabled')
  })
  
  const openThumbnails = document.querySelectorAll('a.open-glightbox')
  openThumbnails.forEach(function (thumbnail) {
    thumbnail.classList.remove('disabled')
    thumbnail.addEventListener('click', handleThumbClick)
  })

  // Initialize form checkboxes
  carSoldCheckbox = document.getElementById('car_sold')
  carReservedCheckbox = document.getElementById('car_reserved')
  carShowSoldOnPublic = document.getElementById('show-sold-on-public')

  if (carSoldCheckbox && carReservedCheckbox) {
    carSoldCheckbox.addEventListener('click', handleCheckboxClick)
    carReservedCheckbox.addEventListener('click', handleCheckboxClick)
    if(carSoldCheckbox.checked) {
      carShowSoldOnPublic.classList.remove('d-none')
    } else {
      carShowSoldOnPublic.classList.add('d-none')
    }
  }
    document.querySelectorAll(".card-link").forEach(link => {
    link.addEventListener("click", function (event) {
      event.preventDefault();

      let targetId = this.getAttribute("href");
      let targetElement = document.querySelector(targetId);

      console.log(targetId)
      console.log(targetElement)
      if (!targetElement) return;

      let isOpen = targetElement.classList.contains("show");
      console.log(isOpen)

      // Close all other collapse elements if inside an accordion
      let parentAccordion = targetElement.getAttribute("data-parent");
      console.log(parentAccordion)
      if (parentAccordion) {
        document.querySelectorAll(parentAccordion + ".show").forEach(el => {
          if (el !== targetElement) {
            el.classList.remove("show");
            el.classList.add("collapse");
          }
        });
      }

      // Toggle the clicked element
      if (isOpen) {
        targetElement.classList.remove("show");
        targetElement.classList.add("collapse");
      } else {
        targetElement.classList.remove("collapse");
        targetElement.classList.add("show");
      }
    });
  });
});
